
export const pages = {
    "/": "page_home",
    "/order-details": "$groupName",
    "/service-request": "$groupName - $serviceName",
    "/service-guide-details": "$groupName - $serviceName",
    "/services": "page_services",
    "/services-guide": "page_servicesGuide",
    "/sign-up": "page_signUp",
    "/my-account": "page_myAccount",
    "/my-orders": "page_myOrders",
    "/my-notifications": "page_myNotifications",
    "/my-services": "page_myServices"
}